import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/assets/videos/Istock-1019298786.mp4")